module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-7.f6acba2.woff2";